import {useEffect, useCallback} from 'react'
import { useQueryClient } from "@tanstack/react-query"
import { showToast } from "../toastSlice"

export default function useSessionTimeout(logoutFunction, enabled, sessionTime){
  const queryClient = useQueryClient();
  let timeout;

  const resetTimeout = useCallback(() => {
    clearTimeout(timeout);
    
    timeout = setTimeout(() => {
      logoutFunction();
      showToast("Session timed out, please log in.");
      queryClient.clear(); // Clear React Query cache on logout
    }, sessionTime);
  }, [logoutFunction, queryClient, sessionTime]);

  useEffect(() => {
    if (!enabled || !sessionTime.length) return;
    const events = ['mousemove', 'keydown', 'scroll'];
    events.forEach((event) => {
      window.addEventListener(event, resetTimeout);
    });

    resetTimeout(); // Initialize the timeout

    return () => {
      clearTimeout(timeout);
      events.forEach((event) => {
        window.removeEventListener(event, resetTimeout);
      });
    };
  }, [resetTimeout, enabled, sessionTime]);

  return null; // This hook doesn't render anything
};